type Props = {
  label: string;
  handleClick: () => void;
  isLoading?: boolean;
  isActive?: boolean;
};
const Button = ({
  label,
  handleClick,
  isLoading = false,
  isActive = false,
}: Props) => {
  return (
    <>
      {isLoading ? (
        <div
          className="font-bold text-center items-center px-4 py-2 mt-4 text-center text-white bg-gradient-to-r rounded-[10000px]"
          style={{
            backgroundImage:
              "linear-gradient(to right, #56c271, #6ff591, #56c271)",
          }}
        >
          Loading...
        </div>
      ) : isActive ? (
        <div
          onClick={handleClick}
          className="font-bold text-center items-center px-4 py-2 mt-4 text-center text-white bg-gradient-to-r rounded-[10000px]"
          style={{
            backgroundImage:
              "linear-gradient(to right, #56c271, #6ff591, #56c271)",
          }}
        >
          {label}
        </div>
      ) : (
        <div
          onClick={handleClick}
          className="font-bold text-center items-center px-4 py-2 mt-4 text-cexnter text-white bg-gradient-to-r rounded-[10000px] hover:bg-slate-300 cursor-pointer"
          style={{
            backgroundImage:
              "linear-gradient(to right, #56c271, #6ff591, #56c271)",
          }}
        >
          {label}
        </div>
      )}
    </>
  );
};

export default Button;
